<template>
  <span class="upgrade-badge"><i class="fas fa-lock"></i> อัปเกรด</span>
</template>

<script>
// ป้ายบอกว่าฟีเจอร์นี้ไม่รวมในแพ็กปัจจุบัน — คู่กับ UpgradeNoticeMixin ที่อธิบายตอนกด
export default {
  name: "UpgradeBadge",
};
</script>

<style scoped>
.upgrade-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.125rem 0.5rem;
  border-radius: 999px;
  background: #fff4db;
  color: #7a4b00;
  font-size: 0.6875rem;
  font-weight: 600;
  line-height: 1.5;
  white-space: nowrap;
}

.upgrade-badge i {
  font-size: 0.85em;
}
</style>
